import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { ClipboardCheck, Save } from "lucide-react";
import { PreregRemoval } from "./PreregRemoval";
import { PreregLog } from "./PreregLog";

// Sezione "Preiscrizioni" dell'anno di lavoro (anno di destinazione)
export const PreregSettingsCard = ({ year, outIds, onChanged }) => {
  const [cfg, setCfg] = useState(null);
  const [form, setForm] = useState({ open: false, info_text: "", date_x: "" });
  const [logs, setLogs] = useState([]);
  const [saving, setSaving] = useState(false);
  const loadLogs = () => api.get("/admin/prereg/logs", { params: { year } }).then((r) => setLogs(r.data)).catch(() => {});
  const apply = (c) => { setCfg(c); setForm({ open: c.open, info_text: c.info_text, date_x: c.date_x }); };
  useEffect(() => {
    setCfg(null);
    api.get("/admin/prereg-config", { params: { year } }).then((r) => apply(r.data)).catch(() => {});
    loadLogs();
  }, [year]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.post("/admin/prereg-config", form, { params: { year } });
      apply(data); toast.success("Preiscrizioni salvate");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); } finally { setSaving(false); }
  };
  if (!cfg) return null;
  const dirty = form.open !== cfg.open || form.info_text !== cfg.info_text || form.date_x !== cfg.date_x;

  return (
    <Card className="p-6 bg-card border-border space-y-4" data-testid="prereg-card">
      <h3 className="text-xl flex items-center gap-2"><ClipboardCheck size={18} className="text-primary" /> Preiscrizioni {year}</h3>
      <p className="text-sm text-muted-foreground">Gli ex allievi portati in {year} e ancora "Da confermare" vedono nella loro area la domanda di preiscrizione, anche se l'anno corrente è un altro. Nessuna email o notifica viene inviata.</p>
      <label className="flex items-center gap-3 text-sm font-medium">
        <Switch data-testid="prereg-open-switch" checked={form.open} onCheckedChange={(v) => setForm({ ...form, open: v })} /> Preiscrizioni aperte
      </label>
      <div><Label className="text-xs">Testo informativo (mostrato all'allievo)</Label>
        <Textarea data-testid="prereg-info-text" rows={5} value={form.info_text} onChange={(e) => setForm({ ...form, info_text: e.target.value })} className="mt-1 bg-white" /></div>
      <div><Label className="text-xs">Data X: ultimo giorno per rispondere (dal giorno dopo chi è ancora "Da confermare" esce dal corso)</Label>
        <div className="flex gap-2 mt-1">
          <Input data-testid="prereg-date-x" type="date" value={form.date_x} onChange={(e) => setForm({ ...form, date_x: e.target.value })} className="bg-white w-48" />
          {form.date_x && <Button variant="ghost" size="sm" data-testid="prereg-date-x-clear" onClick={() => setForm({ ...form, date_x: "" })}>Togli data</Button>}
        </div>
      </div>
      <Button data-testid="prereg-save" disabled={!dirty || saving} onClick={save}><Save size={15} className="mr-1.5" /> Salva preiscrizioni</Button>
      <PreregRemoval year={year} cfg={cfg} onRan={(d) => { apply(d); loadLogs(); onChanged(); }} />
      <PreregLog year={year} logs={logs} outIds={outIds} onRestored={() => { loadLogs(); onChanged(); }} />
    </Card>
  );
};
